import { LIST_TEXTS, LIST_EDITS_FOR_TEXT, SENT_TEXT, LIST_RECENT_TEXTS } from '../actions/text'
import { UPDATE_COMMENTS } from '../actions/comments'

const initialState = {
	userTexts: [],
	textEdits: [],
	sentText: false,
	recentTexts: []
}

export default function textReducer(state=initialState, action) {
	if(action.type === LIST_TEXTS) {
		return Object.assign({}, state, { userTexts: action.texts })
	}
	if(action.type === UPDATE_COMMENTS && !action.update.isEdit) {
		const recentTexts = state.recentTexts.map(text => {
			if(text._id === action.update._id) {
				return action.update
			}
			return text
		})
		const userTexts = state.userTexts.map(text => {
			if(text._id === action.update._id) {
				return action.update
			}
			return text
		})
		return Object.assign({}, state, { userTexts, recentTexts })
	}
	if(action.type === LIST_EDITS_FOR_TEXT) {
		return Object.assign({}, state, { textEdits: action.edits })
	}
	if(action.type === SENT_TEXT) {
		return Object.assign({}, state, { sentText: action.sent })
	}
	if(action.type === LIST_RECENT_TEXTS) {
		return Object.assign({}, state, { recentTexts: action.texts })
	}
	return state
}


// WEBPACK FOOTER //
// ./src/reducers/text.js